module.exports = function() {
  return new Worker(__webpack_public_path__ + "c00bbdd0189e3277df20.worker.js");
};